import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-add-elcm-candidate',
  templateUrl: './add-elcm-candidate.component.html',
  styleUrls: ['./add-elcm-candidate.component.scss'],
})
export class AddElcmCandidateComponent implements OnInit {
  condidateForm!: FormGroup;
  authorities: any[] = [];
  allListingband: any = [];
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserName: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  selectedYear: any;
  pmsYears: any = [];
  userEmail: any;
  @HostListener('window:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault(); // Prevents the default enter key behavior
  }

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddElcmCandidateComponent>,
    @Inject(MAT_DIALOG_DATA) public assetdata: any, private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog,) {

    this.condidateForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      solutation: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],


    });



  }
  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.getpmsyearlist();
  }
  hasError(controlName: any, errorType: any) {
    const control = this.condidateForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  cancelbutton() {
    this.dialogRef.close();
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {

  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {

  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //       if (ele?.year == yearValue) {
  //         console.log("dgmfdgl");

  //         this.selectedYear = ele?.year;

  //         // var test = ele?.year?.split('-');
  //         // this.fromYear = test[0];
  //         // this.toYear = test[1];


  //       }


  //     });
  //   })
  // }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
      this.setSelectedYear(yearValue);
    // Additional function calls
    
    });
  }
setSelectedYear(yearValue: string): void {
  const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
  if (selectedYearObj) {
    this.selectedYear = selectedYearObj?.year;
    let test = selectedYearObj?.year.split('-');
       
  }
}

  addSubmitForm: boolean = false;
  // savecandidatedata() {
  //   let data = this.condidateForm

  //   let formData = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "salutation": data.value.solutation,
  //     "firstName": data.value.firstName,
  //     "lastName": data.value.lastName,
  //     "candidateEmail": data.value.mail,
  //     "hrId": this.loggedInUserId,
  //     "fiscalYear": this.loggedInCompanyFiscalyear,
  //     "year": this.selectedYear,
  //     "hrName": this.loggedInUserName,
  //     "hrMail": this.userEmail
  //   }
  //   if (this.condidateForm.invalid) {

  //     this.addSubmitForm = true;
  //     this.condidateForm.markAllAsTouched();
  //   }


  //   if (this.condidateForm.valid) {

  //     this.httpService.callPostService(`${this.config.candidtaeform}`, formData).subscribe(
  //       (data: any) => {
  //         console.log(data);

  //         if (data) {
  //           // Success popup
  //           const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //             disableClose: true,
  //             height: '25%',
  //             width: '30%',
  //             data: {
  //               msg: data.message,
  //               btn2: 'OK',
  //               btn2BgColor: this.buttonColorName,
  //               showSuccessIcon: true,
  //               showSuccessMessage: false,
  //               showCloseIcon: false
  //             }
  //           });

            
  //           // Handle the result of the dialog
  //           dialogRef.afterClosed().subscribe(() => {
  //             this.dialogRef.close();
  //           });
  //         }
  //       },
  //       (error: any) => {

  //         const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //           disableClose: true,
  //           height: '25%',
  //           width: '30%',
  //           data: {
  //             msg: error.error.error,
  //             btn2: 'OK',
  //             btn2BgColor: 'red', // Highlight error with red button color
  //             showSuccessIcon: false,
  //             showSuccessMessage: false,
  //             showCloseIcon: true
  //           }
  //         });

  //         errorDialogRef.afterClosed().subscribe(() => {
  //           // Optionally handle any action after closing the error dialog
  //           console.log('Error dialog closed');
  //         });
  //       }
  //     );
  //   }
  // }
  isSubmitting = false; // Prevent multiple submissions

  savecandidatedata() {
  if (this.isSubmitting) return; // Prevent duplicate API calls

  if (this.condidateForm.invalid) {
    this.addSubmitForm = true;
    this.condidateForm.markAllAsTouched();
    return;
  }

  this.isSubmitting = true; // Set flag to prevent multiple calls

  let formData = {
    "companyId": this.loggedInUserCompanyID,
    "salutation": this.condidateForm.value.solutation,
    "firstName": this.condidateForm.value.firstName,
    "lastName": this.condidateForm.value.lastName,
    "candidateEmail": this.condidateForm.value.mail,
    "hrId": this.loggedInUserId,
    "fiscalYear": this.loggedInCompanyFiscalyear,
    "year": this.selectedYear,
    "hrName": this.loggedInUserName,
    "hrMail": this.userEmail
  };

  this.httpService.callPostService(`${this.config.candidtaeform}`, formData).subscribe(
    (response: any) => {
      this.showPopup("Added Successfully", 'success', true);
      this.isSubmitting = false; // Reset flag
    },
    (error: any) => {
      this.showPopup(error.error.error || 'An error occurred.', 'danger', false);
      this.isSubmitting = false; // Reset flag
    }
  );
}

// Reusable popup function
showPopup(message: string, color: string, isSuccess: boolean) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: message,
      btn2: 'OK',
      btn2BgColor: color,
      showSuccessIcon: isSuccess,
      showSuccessMessage: false,
      showCloseIcon: !isSuccess
    }
  });

  dialogRef.afterClosed().subscribe(() => {
    if (isSuccess) this.dialogRef.close(); // Close only on success
  });
}

}
